// REMINDER: Please do not commit changes inside the object. Thanks!

// used to hardcode override values for local development
// also used to prevent reloading of a flag from remote changes
// example:

export default {
  // NOTE: uncomment the next line to enable MS program flex:
  // 'feature-learn-18843-ms-program-flex': true,
  // NOTE: uncomment the next line to enable site selection in Middle School:
  // 'feature_LEARN-20108-ms-site-selection': true,
  // NOTE: uncomment the next line to enable site selection in K5 digital:
  // 'feature_LEARN-20164-k5-site-selection': true,
  // NOTE: uncomment the next line to *disable* SSAPI v4 calls (flag is on in DEV):
  // 'feature_LEARN-24754_educator_journey_updates': false,
  // 'feature_LEARN-23137_add-tiered-interventions-to-learn': true,
  // NOTE: uncomment the next line to enable experience player in learn:
  // 'feature_LEARN-26293-experience-player-in-learn': true,
  // NOTE: uncomment the next line to enable lesson page update:
  // 'feature_LEARN-28473-learn-k12-core-curriculum-service-integration': true,
  // 'feature_LEARN-28095-class-sharing': true,
  // 'feature_LEARN-29157-export-button-update': true,
  // 'feature_LEARN-29656-Simplify-HS-Setup': true,
  // NOTE: uncomment the next line to enable the educator High School dashboard simplification (HighSchoolProgramCard/InstanceView):
  // 'feature_LEARN-29656-Educator-HS-Simplification': true,
  // NOTE: uncomment the next line to enable subnav breadcrumbs:
  // 'feature_LEARN-18963-subnav-breadcrumbs': true,
}
